const TEMP_MESSAGE_ID_PREFIX = 'temp-id:';

export const getTempMessageId = (date: string): string => `${TEMP_MESSAGE_ID_PREFIX}${date}`;

/** Whether the id is a placeholder for a sent message the server hasn't acknowledged yet. */
export const isTempMessageId = (id: string): boolean => id.startsWith(TEMP_MESSAGE_ID_PREFIX);
